import type { TransactionTableRow } from '@peanuds/shared';
import type { Transaction } from '@peanuds/shared-state';

export type ControlSpendingTableRow = TransactionTableRow;

const toString = (value: unknown): string => {
  return typeof value === 'string' ? value : '';
};

export const mapTransactionToTableRow = (
  transaction: Transaction,
  _index: number,
): ControlSpendingTableRow => {
  const transactionId = toString(transaction.id);

  return {
    ...transaction,
    id: transactionId || undefined,
    state: transaction.status,
    status: transaction.status,
    direction: transaction.direction,
    dateAndTime: transaction.transferDate || '',
    transactionId,
    amount: transaction.amount ?? undefined,
    type: transaction.type,
  };
};
